import apiManagerRecordings from "api/recordings"
import { DIALOG_ID } from "components/Dialog/constant"
import { NS_TRANS, TYPE_GET_ERR_CODE } from "constants/common"
import { useTranslation } from "react-i18next"
import { useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import { setCloseCurrentDialog } from "store/dialogSlice"
import { ROUTE_PATH } from "constants/route"
import { localLog } from "utils/functions/common"
import { setCloseDialogCC, setOpenDialogCC, toastError, toastErrorFetchAPI, toastSuccess } from "utils/helpers"
import { toggleRefreshTableDataV2 } from "../store/managerRecordingSlice"
import { PATH_ROOT } from "constants/api"

export function getTotalSizeRecords(records) {
    if (!records) return 0
    else {
        try {
            const totalSize = records.reduce(
                (currentValue, record) => record?.file_size + currentValue,
                0,
            );

            return (totalSize / (1024 * 1024)).toFixed(2)
        } catch (err) {
            console.log("err: ", err);
        }
    }
}

const useHandleManagerRecording = () => {

    const navigate = useNavigate()
    const { t } = useTranslation(NS_TRANS.PG_RECORDINGS)
    const { t: tcm } = useTranslation()
    const dispatch = useDispatch()

    const handleDeleteOneRecord = ({ recordId, recordName }) => {
        setOpenDialogCC({
            id: DIALOG_ID.CONFIRM,
            props: {
                title: t('actions.deleteRecord'),
                contentText: <div>{t('dialog.confirmDeleteOneRecord')} <span style={{ fontWeight: '700', wordBreak: 'break-all'}}>{recordName}</span></div>,
                onClick: () => { actionDeleteOneRecord(recordId) },
                isDisableLoadingButton: true
            }
        })
    }

    const handleDeleteListRecords = ({recordIds, setSelected}) => {
        setOpenDialogCC({
            id: DIALOG_ID.CONFIRM,
            props: {
                title: t('actions.deleteListRecords'),
                contentText: t('dialog.confirmDeleteListRecord', { num: recordIds?.length }),
                onClick: () => { actionDeleteListRecords({recordIds, setSelected}) },
                isDisableLoadingButton: true
            }
        })
    }

    const navigateDetailRecord = (record) => {
        if (record) navigate(`${PATH_ROOT}/${ROUTE_PATH.MANAGE_RECORD.DETAIL_RECORD}/${record?.record_info_id}`)
    }

    const navigateSharingRecord = (record) => {
        if (record) navigate(`${PATH_ROOT}/${ROUTE_PATH.MANAGE_RECORD.SHARING_RECORD}/${record?.record_info_id || record?.id}`)
    }

    /**
     * Xóa 1 bản ghi trong danh sách
     * @param {*} recordId 
     * @returns 
     */
    const actionDeleteOneRecord = async (recordId) => {
        try {
            const body = {
                "record_ids": [recordId]
            }
            const res = await apiManagerRecordings.deleteRecordIds({ body })

            if (res.data) {
                toastSuccess(tcm('toast.trashSuccess'))
                dispatch(setCloseCurrentDialog())
                setCloseDialogCC()
                return dispatch(toggleRefreshTableDataV2())
            }
            return toastErrorFetchAPI({ result: res.data, typeErrCode: TYPE_GET_ERR_CODE.RECORDING, tcm: tcm, toastError: toastError })
        } catch (err) {
            toastErrorFetchAPI({ result: { code: err?.status || 500 }, typeErrCode: TYPE_GET_ERR_CODE.RECORDING, tcm: tcm, toastError: toastError })
            localLog("Error action delete one record: ", err)
        }
    }

    const actionDeleteListRecords = async ({recordIds = [], setSelected}) => {
        try {
            const body = {
                "record_ids": recordIds
            }
            const res = await apiManagerRecordings.deleteRecordIds({body})

            if(res.data) {
                toastSuccess(t('toast.trashSuccess'))
                dispatch(setCloseCurrentDialog())
                setCloseDialogCC()
                setSelected([])
                return dispatch(toggleRefreshTableDataV2())
            }
            return toastErrorFetchAPI({ result: res.data, typeErrCode: TYPE_GET_ERR_CODE.RECORDING, tcm: tcm, toastError: toastError })
        } catch (err) {
            toastErrorFetchAPI({ result: { code: err?.status || 500 }, typeErrCode: TYPE_GET_ERR_CODE.RECORDING, tcm: tcm, toastError: toastError })
            localLog("Error action delete list records: ", err)
        }
    }

    return {
        handleDeleteOneRecord,
        navigateDetailRecord,
        navigateSharingRecord,
        handleDeleteListRecords
    }
}

export default useHandleManagerRecording